'use client';

import React from 'react';
import styled from '@benzinga/themetron';
import Hooks from '@benzinga/hooks';
import classnames from 'classnames';

export interface GridProps {
  className?: string;
  columnsSize?: {
    sm?: number;
    md?: number;
    lg?: number;
  };
  maxColumns?: number;
  style?: React.CSSProperties;
}

export const Grid: React.FC<React.PropsWithChildren<GridProps>> = ({
  children,
  className,
  columnsSize = {},
  maxColumns = 3,
  style,
}) => {
  const [columns, setColumns] = React.useState<number>(2);
  const ref = React.useRef<HTMLDivElement>(null);

  const updateColumns = React.useCallback(() => {
    const width = ref?.current?.offsetWidth ?? 0;
    let columns = columnsSize.sm ?? 1;
    if (width > 900) {
      columns = columnsSize.lg ?? 3;
    } else if (width > 550) {
      columns = columnsSize.md ?? 2;
    } else {
      columns = columnsSize.sm ?? 1;
    }
    if (columns > maxColumns) {
      columns = maxColumns;
    }
    setColumns(columns);
  }, [columnsSize?.lg, columnsSize?.md, columnsSize?.sm, maxColumns]);

  React.useEffect(() => {
    updateColumns();
  }, [updateColumns]);

  Hooks.useEventListener('resize', updateColumns);

  return (
    <GridWrapper
      className={classnames('grid-wrapper', { [`${className}`]: !!className })}
      columns={columns}
      ref={ref}
      style={style}
    >
      {children}
    </GridWrapper>
  );
};

const GridWrapper = styled.div<{ columns: number }>`
  width: 100%;
  gap: 16px;
  display: grid;
  grid-template-columns: repeat(${({ columns }) => columns}, minmax(0, 1fr));
  grid-template-rows: min-content min-content;
  margin: 12px 0;

  .listing-preview {
    margin-bottom: 0px;
  }
`;
